<template>
  <scroll-bar>
    <div class="logoWrapper">
      <!-- <img width="52" height="25" src="../../../../assets/images/logo.png" alt=""> -->
      <div class="logoTitle">订货通</div>
    </div>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#252733"
      text-color="#bfcbd9"
      active-text-color="#3670FF"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      // return this.$router.options.routes
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .logoWrapper{
     text-align: center;
     padding: 30px;
    .logoTitle{
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 50px;
      text-align: center;
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue